import axios, { AxiosRequestConfig } from 'axios';
import { DataResponse, PagedResponse } from '../types/api';
import { SpecialService } from '../types/SpecialService';

const URL = '/v2/special-services';

class SpecialServicesService {
  static getByFilter(config?: AxiosRequestConfig): Promise<PagedResponse<SpecialService>> {
    return axios.get(URL, config);
  }

  static getByFilterForAdmin(config?: AxiosRequestConfig): Promise<PagedResponse<SpecialService>> {
    return axios.get(`${URL}?includeDisabled=true`, config);
  }

  static patch(
    id: number,
    data: SpecialService,
    config?: AxiosRequestConfig
  ): Promise<DataResponse<SpecialService>> {
    return axios.patch(`${URL}/${id}`, data, config);
  }

  static update(
    id: number,
    data: SpecialService,
    config?: AxiosRequestConfig
  ): Promise<DataResponse<SpecialService>> {
    return axios.put(`${URL}/${id}`, data, config);
  }

  static create(
    data: SpecialService,
    config?: AxiosRequestConfig
  ): Promise<DataResponse<SpecialService>> {
    return axios.post(URL, data, config);
  }

  static delete(id: number, config?: AxiosRequestConfig) {
    return axios.delete(`${URL}/${id}`, config);
  }
}

export { SpecialServicesService };
